export default __webpack_public_path__ + "static/media/db.ef610195.svg";